import { LocalizationService } from 'src/app/service/localization.service';
import { TvFeature } from '../data/enum/tv-feature';
import { JsonKey } from '../data/type/locale-copy-key';
import { RemoteButtonKey } from '../data/type/remote-button';
import { ShowcasePageStep } from '../data/type/tv-feature-step';

const getRecommendationsTvFeatureSteps = (
  localizationService: LocalizationService,
): Array<ShowcasePageStep> => {
  return [
    {
      activeButtonKeys: [RemoteButtonKey.up],
      tooltipCopy: localizationService.translate(JsonKey.RECOMMENDATIONS_COACHMARK_1),
    },
    {
      activeButtonKeys: [RemoteButtonKey.center, RemoteButtonKey['center-hisense']],
      tooltipCopy: localizationService.translate(JsonKey.RECOMMENDATIONS_COACHMARK_2),
    },
    {
      activeButtonKeys: [],
      tooltipCopy: '',
    },
  ];
};

const getBrowseTitlesFeatureSteps = (
  localizationService: LocalizationService,
): Array<ShowcasePageStep> => {
  return [
    // {
    //   activeButtonKeys: [RemoteButtonKey.center],
    //   tooltipCopy: '',
    // },
    {
      activeButtonKeys: [RemoteButtonKey.center, RemoteButtonKey['center-hisense']],
      tooltipCopy: localizationService.translate(JsonKey.BROWSE_TITLES_COACHMARK_1),
      secondTooltipCopy: localizationService.translate(JsonKey.BROWSE_TITLES_COACHMARK_2),
    },
    {
      activeButtonKeys: [],
      tooltipCopy: '',
    },
  ];
};

const getWatchlistFeatureSteps = (
  localizationService: LocalizationService,
): Array<ShowcasePageStep> => {
  return [
    {
      activeButtonKeys: [RemoteButtonKey.center, RemoteButtonKey['center-hisense']],
      tooltipCopy: localizationService.translate(JsonKey.WATCHLIST_COACHMARK_1),
    },
    {
      activeButtonKeys: [],
      tooltipCopy: '',
    },
  ];
};

const getVoiceFeatureSteps = (): Array<ShowcasePageStep> => {
  return [];
};

export const getSteps = (
  feature: TvFeature,
  localizationService: LocalizationService,
): Array<ShowcasePageStep> => {
  const featureMap = {
    [TvFeature.BROWSE_TITLES]: getBrowseTitlesFeatureSteps,
    [TvFeature.RECOMMENDATIONS]: getRecommendationsTvFeatureSteps,
    [TvFeature.WATCHLIST]: getWatchlistFeatureSteps,
    [TvFeature.VOICE]: getVoiceFeatureSteps,
  };

  return featureMap[feature](localizationService);
};
